import styled from "styled-components";
import Banner from "../../assets/images/img-banner.jpeg";

export const Wrapper = styled.div`
    background-image: url(${Banner});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: fixed;
    width: 100%;
    height: 100%;
    overflow: auto;
    display: flex;
    align-items: flex-end;

`;

export const NotificationWrapper = styled.div`
    width: 100%;
    height: 500px;
    background: white;
    border-top-right-radius: 40px;
    border-top-left-radius: 40px;

    .top-tabs {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 30px;
        margin-top: 20px;

        .tab {
            font-size: 14px;
            font-weight: bold;
        }
        .active {
            border-bottom: 2px solid #3996b8;
        }
    }
    .body-container {
        padding: 10px 20px;
        margin-top: 10px;
        height: 240px;
        overflow: auto;

        .content {

            .msg-div {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
                margin-bottom: 15px;

                .start {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 20px;

                    .avatar {
                        border-radius: 50%;
                        width: 30px;
                        height: 30px;
                    }

                    .sender {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start;
                        align-items: flex-start;
                        gap: 3px;

                        .sender-name {
                            font-size: 16px;
                            font-weight: 600;
                        }

                        .message {
                            font-size: 12px;
                        }
                        
                    }
                }
            }
        }
    }

    .input-container {
        padding: 10px 20px;
        margin-top: 10px;
        position: relative;

        .input {
            border: none;
            background: #fafafa;
            width: 100%;
            border-radius: 10px;
            outline: none;
            font-size: 14px;
            color: #3c3c3c;
            padding: 5px 10px 5px 40px;
            box-shadow: 2px 2px 20px #c6c6c6;
        }
        .texto {
            position: absolute;
            font-size: 12px;
            font-weight: bold;
            left: 30px;
            top: 18px;
        }

        
    }

    .send-container {
        padding: 10px 20px;

        .hr {
            height: 1px;
            width: 100%;
            background: #cccccc;
        }

        .input-send {
            border: none;
            outline: none;
            width: 100%;
            padding: 0 10px;
        }

        .icons {
            display: flex;
            flex: 1;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .add-link-icon {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
            }
        }

    }
`;

export const ListContainer = styled.div`
    height: 200px;
    overflow: auto;
    min-width: 220px
`
export const ListValueContainer = styled.div`
    padding: 10px;

    .checkbox-cont {
        width: 100%;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
    }

    .ant-checkbox-wrapper::after {
        display: none;
    }

`